/**
 * @file HeaderWizardSlot.tsx
 *
 * @fileoverview This component can be used to render custom things on top of wizard pages.
 */

export const HeaderWizardSlot = () => {
  return null;
};

export default HeaderWizardSlot;
